<template>
    <div>
        <b-card header-tag="header" footer-tag="footer" class="mt-8">
            <template v-slot:header>
                <p class="mb-0" style="font-size: 21px">Configuración de la aplicación</p>
            </template>
            <b-row>
                <b-col cols="12" md="4">
                    <label>Dirección principal</label>
                    <b-input-group>
                        <b-form-input v-model="configuracion.direccion" placeholder="Dirección"></b-form-input>
                    </b-input-group>
                </b-col>
                <b-col cols="12" md="4">
                    <label>Email de contacto</label>
                    <b-input-group>
                        <b-form-input v-model="configuracion.email_contacto" placeholder="Email de contacto"></b-form-input>
                    </b-input-group>
                </b-col>
                <b-col cols="12" md="4">
                    <label>Teléfono de contacto</label>
                    <b-input-group>
                        <b-form-input v-model="configuracion.telefono" placeholder="Teléfono de contacto"></b-form-input>
                    </b-input-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col cols="12" md="4">
                    <label>Horarios</label>
                    <b-input-group>
                        <b-form-input v-model="configuracion.horarios" placeholder="Horarios"></b-form-input>
                    </b-input-group>
                </b-col>
                <b-col cols="12" md="4">
                    <label>Color texto menu</label>
                    <b-form-input type="color" v-model="configuracion.menu_color" value="#ffffff"></b-form-input>
                </b-col>
            </b-row>
            
            <b-button class="mt-10" variant="info" @click.prevent="setConfigurationMaster()" >
                Actualizar Información
            </b-button>
        </b-card>
        <image-list />
    </div>
</template>
<script>
import ImageList from './ImageList.vue'
import { mapActions, mapMutations } from 'vuex'
export default {
    data(){
        return{
            configuracion: {
            },
        }    
    },
    components: {
        ImageList
    },
    created(){
        this.getConfigurationMaster();
    },
    methods: {
        ...mapMutations(['setLoading']),
        ...mapActions('configuration', ['getConfiguration']),
        async getConfigurationMaster(){
            this.setLoading(true);
            await this.$conectar.post('cliente-web/configuracion/get-configuration-master')
            .then(response =>{
                this.configuracion = response.data.configuracion;
                this.configuracion.horarios = JSON.parse(this.configuracion.horarios);
                
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false);
        },
        async setConfigurationMaster(){
            this.setLoading(true);
            
            await this.$conectar.post('cliente-web/configuracion/set-configuration-master', this.configuracion)
            .then(response =>{
                if(response.data.error == false){
                    this.setLoading(false);
                    this.getConfigurationMaster();
                    this.$bvToast.toast('Configuración actualizada correctamente', {
                        title: "Respuesta del servidor",
                        variant: "success",
                        solid: true
                    });
                }else{
                    this.$bvToast.toast('Hubo un error al actualizar la configuración', {
                        title: "Respuesta del servidor",
                        variant: "danger",
                        solid: true
                    })
                }
            })
            .catch(e => {
                console.log(e.response);
                this.$bvToast.toast('Hubo un error al actualizar la configuración', {
                    title: "Respuesta del servidor",
                    variant: "danger",
                    solid: true
                })
            })
            this.setLoading(false);
            
        }
        
    }
}
</script>